import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import ApiProvider from '../../../core/api/ApiProvider';
import { Alert, Button, Loader, ModuleContainer } from '../../../core/components';
import { TranslationService } from '../../../core/services';
import Status from '../../../core/types/Status';
import { PaymentInfo } from './types/PaymentInfo';
import styles from './PaymentDetails.module.scss';

const PaymentDetails = () => {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [paymentInfo, setPaymentInfo] = useState<PaymentInfo>();
  const history = useHistory();

  const loadPaymentInfo = async () => {
    setIsLoading(true);
    const result = await ApiProvider.get<Status<PaymentInfo>>(
      `Payment/Pay${window.location.search}`
    );
    setPaymentInfo(result.data);
    setIsLoading(false);
  };

  const successPayment = () => {
    if (!paymentInfo) return;
    return (
      <>
        <Alert variant={Alert.Variants.Success} className="mb-2">
          {TranslationService.translate('TransactionComplete')}
        </Alert>
        <div className={styles['payment-confirmation-container']}>
          <p className={styles['payment-confirmation']}>
            {TranslationService.translate('CreditorName')}:
          </p>
          <p className={styles['payment-confirmation']} data-cy={'creditorNo'}>{paymentInfo.creditorNo}</p>
        </div>
        <div className={styles['payment-confirmation-container']}>
          {paymentInfo.isARMCase ? (
            <>
              <p className={styles['payment-confirmation']}>
                {TranslationService.translate('InvoiceNr')}:
              </p>
              <p className={styles['payment-confirmation']} data-cy={'invoiceNo'}>{paymentInfo.invoiceNo}</p>
            </>
          ) : (
            <>
              <p className={styles['payment-confirmation']}>
                {TranslationService.translate('CaseNr')}:
              </p>
              <p className={styles['payment-confirmation']} data-cy={'caseNo'}>{paymentInfo.caseNo}</p>
            </>
          )}
        </div>
        <div className={styles['payment-confirmation-container']}>
          <p className={styles['payment-confirmation']}>
            {TranslationService.translate('PaymentDate')}:
          </p>
          <p className={styles['payment-confirmation']} data-cy={'datePaid'}>{paymentInfo.datePaid}</p>
        </div>
        <div className={styles['payment-confirmation-container']}>
          <p className={styles['payment-confirmation']}>
            {TranslationService.translate('TotalPaid')}:
          </p>
          <p className={styles['payment-confirmation']} data-cy={'amount'}>{paymentInfo.amount}</p>
        </div>
        <div className={styles['payment-confirmation-container']}>
          {paymentInfo.isARMCase ? (
            <>
              <p className={styles['payment-confirmation']}>
                {TranslationService.translate('Kid')}:
              </p>
              <p className={styles['payment-confirmation']} data-cy={'kid'}>{paymentInfo.kid}</p>
            </>
          ) : (
            <>
              <p className={styles['payment-confirmation']}>
                {TranslationService.translate('CaseRef')}:
              </p>
              <p className={styles['payment-confirmation']} data-cy={'caseRef'}>{paymentInfo.caseRef}</p>
            </>
          )}
        </div>
        <div className="hidden-print">
          <Button onClick={printPage} variant={Button.Variants.Primary} classNames="mt-1 mr-1">
            {TranslationService.translate('Print')}
          </Button>
          <Button onClick={() => history.push('/')} variant={Button.Variants.Secondary}>
            {TranslationService.translate('BackHome')}
          </Button>
        </div>
      </>
    );
  };

  const printPage = () => {
    window.print();
  };

  const canceledPayment = () => {
    return (
      <>
        <Alert variant={Alert.Variants.Warning} className="mb-2">
          {TranslationService.translate('BankPaymentErrorTransactionCancelled')}
        </Alert>
        <Button onClick={() => history.push('/')} variant={Button.Variants.Secondary}>
          {TranslationService.translate('BackHome')}
        </Button>
      </>
    );
  };

  const errorPayment = () => {
    return (
      <>
        <Alert variant={Alert.Variants.Error} className="mb-2">
          {TranslationService.translate('BankPaymentError')}
        </Alert>
        <Button onClick={() => history.push('/')} variant={Button.Variants.Secondary}>
          {TranslationService.translate('BackHome')}
        </Button>
      </>
    );
  };

  const getProperPaymentInfo = () => {
    if (
      paymentInfo &&
      paymentInfo !== null &&
      !paymentInfo.cancelledByUser &&
      !paymentInfo.endsWithError
    ) {
      return successPayment();
    } else if (
      paymentInfo &&
      paymentInfo !== null &&
      paymentInfo.cancelledByUser &&
      !paymentInfo.endsWithError
    ) {
      return canceledPayment();
    } else {
      return errorPayment();
    }
  };

  useEffect(() => {
    loadPaymentInfo();
  }, []);
  return (
    <ModuleContainer>
      <ModuleContainer.Header title={TranslationService.translate('CustomerInfo')} />
      <ModuleContainer.Body>
        {isLoading && <Loader opacity={0.4} />}
        {!isLoading && getProperPaymentInfo()}
      </ModuleContainer.Body>
    </ModuleContainer>
  );
};

export default PaymentDetails;
